import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dso-guard-authoring-tools',
  templateUrl: './dso-guard-authoring-tools.component.html',
  styleUrls: ['./dso-guard-authoring-tools.component.scss']
})
export class DsoGuardAuthoringToolsComponent {
  
    constructor(private router: Router) {}
     sidebarActive: boolean = true;
}
